export const getCalendarEventModalSteps = (t) => [
    {
        target: '[data-tour="cem-modal"]',
        placement: 'center',
        title: t('tour.calendarEventModal.step-welcome-title'),
        content: t('tour.calendarEventModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cem-dates"]',
        title: t('tour.calendarEventModal.step-dates-title'),
        content: t('tour.calendarEventModal.step-dates-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cem-client"]',
        title: t('tour.calendarEventModal.step-client-title'),
        content: t('tour.calendarEventModal.step-client-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cem-type"]',
        title: t('tour.calendarEventModal.step-type-title'),
        content: t('tour.calendarEventModal.step-type-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="cem-footer"]',
        title: t('tour.calendarEventModal.step-footer-title'),
        content: t('tour.calendarEventModal.step-footer-content'),
        disableBeacon: true,
    },
];
